<template>
  <div class="main-chapter1">
    <n-loader :loading="$var('load')" />

    <br />
    <br />
    <n-input title="Исполнитель (мастер, прораб)" value.sync="" />
    <br />
    <p>
      1.7.1. Записи в журналах должны производиться непосредственно у места погружения свай. Ведение черновых записей
      на отдельных листах, тетрадях и т.п. с последующим переписыванием в журнал категорически запрещается.
    </p>
    <p>
      1.7.2. В графе «Примечание» указываются: причина и длительность задержек в производстве работ по погружению свай,
      а также отмечаются все случаи их повреждения.
    </p>
    <p>
      1.7.3. В случае замены оборудования, указанного на заглавном листе, в журнале делаются соответствующие записи.
    </p>
    <n-items v-if="project">
      <n-input title="Представитель технического надзора" value="" />
      <n-input title="Представитель авторского надзора" value="" />
      <n-input title="Начальник участка (ст. прораб)" value="" />
      <n-input title="Начальник производственно-технического отдела" value="" />
      <!--      <n-button @click="submit" color="success">Сохранить</n-button>-->
    </n-items>
  </div>
</template>

<script>
export default {
  name: 'MainChapter4',
  props: [ 'project', 'journal', ],
  data: () => ({
    data: [],
  }),
  computed: {
    columns() {
      if (!this.journal?.front) {
        return []
      } else {
        return [
          ...this.journal.front.index[2].content,
          { name: 'tools', title: '', },
        ]
      }
    },
    createRecordLink() {
      return { query: { ...this.$route.query, 'new-record': null, }, }
    },
  },
  watch: {
    project() {
      this.load()
    },
  },
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.$var('load', true)
      $api.journalsOld.records.get(this.project.id, this.$route.params.journal, 'records').then((response) => {
        this.data = response.data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .main-chapter1 {
    &::v-deep {
      .n-table .row.header .cell {
        min-width: 100px;
      }
    }
  }
</style>
